import AbstractHybrisApi from '@/api/AbstractHybrisApi';
const OS_CHANNEL = 'OS';

export default class OrderApi extends AbstractHybrisApi {
  orderHistory(userId: string, fields: string, olderThanTS: string, newerThanTS: string, lang: null | string) {
    const currentTime = new Date().getTime();

    return this.request({
      method: 'get',
      version: 'v5',
      url: `/users/${userId}/orderhistory`,
      params: {
        fields,
        newerThanTS,
        olderThanTS,
        currentTime,
        lang,
      },
    });
  }

  singleOrder(userId: string, code: string, lang: null | string) {
    return this.request({
      method: 'get',
      version: 'v5',
      url: `/users/${userId}/orderhistory/${code}`,
      params: {
        fields: 'FULL',
        lang,
      },
    });
  }

  receiptHistory(userId: string, fields: string, olderThanTS: string, newerThanTS: string, lang: null | string) {
    const currentTime = new Date().getTime();

    return this.request({
      method: 'get',
      version: 'v3',
      url: `/users/${userId}/receipthistory`,
      params: {
        fields,
        newerThanTS,
        olderThanTS,
        currentTime,
        lang,
      },
    });
  }

  singleReceipt(
    userId: string,
    code: string,
    orderDateShort: string,
    storeNumber: string,
    workstationId: string,
    lang: null | string,
  ) {
    return this.request({
      method: 'get',
      version: 'v3',
      url: `/users/${userId}/receipthistory/${code}`,
      params: {
        fields: 'FULL',
        orderDateShort,
        storeNumber,
        workstationId,
        lang,
      },
    });
  }

  initialize(userId: string, cartId: string, data: string, lang: null | string) {
    return this.request({
      method: 'post',
      version: 'v2',
      url: `/users/${userId}/orders/initialize`,
      params: {
        fields: 'FULL',
        cartId,
        lang,
      },
      data,
    });
  }

  create(userId: string, cartId: string, transactionId: string, data: Record<string, any>, lang: null | string) {
    return this.request({
      method: 'post',
      version: 'v2',
      url: `/users/${userId}/orders`,
      params: {
        fields: 'FULL',
        cartId,
        transactionId,
        lang,
      },
      data,
    });
  }

  find(userId: string, code: string) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: `/users/${userId}/orders/${code}`,
      params: {
        fields: 'FULL',
      },
    });
  }

  buyAgainProducts(userId: string) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: `/users/${userId}/buyagain`,
      params: {
        fields: 'FULL',
      },
    });
  }

  getDigitalReturn(orderId: string, email: string, businessOrderDay: string) {
    return this.request({
      method: 'get',
      version: 'v4',
      url: `/orders/${orderId}`,
      params: {
        email,
        businessOrderDay,
      },
    });
  }

  orderReturn(orderId: string, email: string, businessOrderDay: string, lineItems: Record<string, any>) {
    return this.request({
      method: 'post',
      version: 'v4',
      url: `/orders/${orderId}/return?businessOrderDay=${businessOrderDay}&email=${email}`,
      data: {
        channel: OS_CHANNEL,
        lineItems,
      },
    });
  }
}
